import mitt from 'mitt';

const mitter = mitt();

export default mitter;
